import { 
  ShieldCheck, Landmark, Smartphone, BrainCircuit, 
  Layout, BookOpen, Fuel, CreditCard, Zap, 
  TrendingUp, BarChart3, Users, Heart
} from 'lucide-react';
import { TrainingServiceType } from '../components/custom/TrainingLiveShowcase/TrainingLiveShowcase';

export interface FeatureContent {
  id: string;
  badge: string;
  title1: string;
  title2: string;
  description: string;
  gradient: string;
  serviceType: TrainingServiceType;
  heroImage: string;
  benefits: Array<{
    title: string;
    description: string;
    icon: any;
  }>;
  stats: Array<{
    label: string;
    value: string;
  }>;
}

export const featuresData: Record<string, FeatureContent> = {
  conciliacao: {
    id: 'conciliacao',
    badge: 'Gestão Financeira',
    title1: 'Conciliação Bancária:',
    title2: 'Sua auditoria automática.',
    description: 'Sincronize as vendas do seu posto com sua conta bancária sem esforço. Identifique divergências em segundos e garanta que cada centavo das suas taxas esteja correto.',
    gradient: 'linear-gradient(135deg, #4f46e5 0%, #0ea5e9 100%)',
    serviceType: 'conciliacao',
    heroImage: 'https://images.unsplash.com/photo-1551288049-bbbda536339a?q=80&w=1200&auto=format&fit=crop',
    benefits: [
      {
        title: 'Auditoria de Taxas',
        description: 'Verificação automática se as taxas cobradas pelas operadoras batem com o contratado.',
        icon: TrendingUp
      },
      {
        title: 'Controle de Lotes',
        description: 'Acompanhe o status de cada lote de venda, desde a pista até o depósito bancário.',
        icon: Landmark
      },
      {
        title: 'Divergências',
        description: 'Alerta imediato para pagamentos não realizados ou valores divergentes.',
        icon: ShieldCheck
      },
      {
        title: 'Fluxo Previsto',
        description: 'Visão clara de quando e quanto você vai receber nos próximos 30 dias.',
        icon: BarChart3
      }
    ],
    stats: [
      { label: 'Precisão', value: '100%' },
      { label: 'Tempo Salvo', value: '15h/mês' },
      { label: 'Operadoras', value: '+50' }
    ]
  },
  smartpos: {
    id: 'smartpos',
    badge: 'Mobilidade e Pista',
    title1: 'Lukos Pay: Baixe abastecimentos',
    title2: 'diretamente na maquininha.',
    description: 'O Lukos Pay transforma sua máquina de cartões em um terminal de retaguarda móvel. Realize a baixa dos abastecimentos, aceite Pix e emita notas sem sair da bomba.',
    gradient: 'linear-gradient(135deg, #f97316 0%, #f59e0b 100%)',
    serviceType: 'smartpos',
    heroImage: 'https://i.pinimg.com/1200x/f6/08/22/f608220ff9354a9bd1aaa0122847a8c2.jpg',
    benefits: [
      {
        title: 'Pix na Bomba',
        description: 'Confirmação instantânea de pagamento Pix direto na tela da maquininha.',
        icon: Zap
      },
      {
        title: 'Fechamento de Pista',
        description: 'Frentista encerra seu turno e imprime o relatório direto no Smart POS.',
        icon: Smartphone
      },
      {
        title: 'Integração de Bico',
        description: 'Leitura automática do abastecimento, eliminando erros de digitação.',
        icon: Fuel
      },
      {
        title: 'Fidelidade em Mãos',
        description: 'Identifique o cliente e aplique pontos de fidelidade no momento do pagamento.',
        icon: Heart
      }
    ],
    stats: [
      { label: 'Giro de Pista', value: '+30%' },
      { label: 'Confirmação', value: '< 2s' },
      { label: 'Erro Humano', value: '-95%' }
    ]
  },
  lmc: {
    id: 'lmc',
    badge: 'Conformidade ANP',
    title1: 'LMC Digital: Adeus ao papel',
    title2: 'e erros de preenchimento.',
    description: 'Gerencie seu Livro de Movimentação de Combustíveis de forma 100% digital, atendendo à nova resolução da ANP com segurança e agilidade.',
    gradient: 'linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%)',
    serviceType: 'general',
    heroImage: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1200&auto=format&fit=crop',
    benefits: [
      {
        title: 'Geração Automática',
        description: 'O sistema preenche o LMC com base nas vendas e medições de estoque do dia.',
        icon: BookOpen
      },
      {
        title: 'Resolução ANP',
        description: 'Totalmente adequado às exigências fiscais e regulatórias do setor.',
        icon: ShieldCheck
      },
      {
        title: 'Exportação PDF',
        description: 'Gere arquivos prontos para fiscalização com apenas um clique.',
        icon: Layout
      },
      {
        title: 'Histórico na Nuvem',
        description: 'Acesse registros de anos atrás sem precisar de pastas físicas ou arquivos.',
        icon: BrainCircuit
      }
    ],
    stats: [
      { label: 'Sustentável', value: 'Zero Papel' },
      { label: 'Fiscalização', value: '100% OK' },
      { label: 'Custo Arquivo', value: '-80%' }
    ]
  }
};
